import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

type Props = {
    extraClassName: string;
    messageId: string;
    strongMessageId: string;
};

const DefaultMessage = ({ extraClassName, messageId, strongMessageId }: Props) => {
    return (
        <FormattedMessage
            id={messageId}
            values={{
                extra: '',
                strong: (
                    <StyledDefaultMessage
                        className={extraClassName}
                        key="default-message-strong"
                    >
                        <FormattedMessage id={strongMessageId} />
                    </StyledDefaultMessage>
                ),
            }}
        />
    );
};

export default React.memo<Props>(DefaultMessage);

const StyledDefaultMessage = styled(H5)`
    text-transform: uppercase;
`;
